import React from 'react';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import _ from 'lodash';
import Tooltip from 'react-tooltip';
import I18n from '../../../i18n/I18n';
import styles from './Stocks.scss';
import { ProductNameBox, Icon } from '../../common/';
import Helper from '../../../helper/Helper';
import { StockBox } from '../index';

const Stocks = props => {
    const {
        browser,
        data,
        searchString,
        inventoryType,
        sortColumn,
        keyVal,
        dir,
    } = props;

    const property = Helper.validator(data);

    const rows =
        data && !_.isEmpty(data)
            ? data.map((item, index) => {
                  const itemProp = item.items
                      ? Helper.validator(item.items)
                      : '';
                  return (
                      <tr className={styles.row}>
                          {property.haveName ? (
                              <td>
                                  <a
                                      target="_blank"
                                      href={`${Helper.getAppDomain(
                                          'catalog',
                                      )}/${Helper.getLocale()}/catalog/${
                                          item.psku_canonical
                                      }`}
                                  >
                                      <ProductNameBox
                                          hideBadge
                                          data={item}
                                          searchString={searchString}
                                      />
                                  </a>
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('sku') ? <td>{item.sku}</td> : ''}
                          {property.haveVal('partner_sku_unique') ? (
                              <td>{item.partner_sku_unique || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('pending_shipment') ? (
                              <td>{item.pending_shipment || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('created_at') ? (
                              <td>
                                  <div
                                      style={{
                                          whiteSpace: 'nowrap',
                                      }}
                                  >
                                      {item.created_at
                                          ? moment(item.created_at).format(
                                                'YYYY-MM-DD',
                                            )
                                          : '-'}
                                  </div>
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('barcode_box') ||
                          inventoryType === 2 ||
                          inventoryType === 3 ? (
                              <td>{item.barcode_box || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('reason_code') ||
                          inventoryType === 2 ||
                          inventoryType === 3 ? (
                              <td>{item.reason_code || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('area_code') ? (
                              <td>{item.area_code}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('zone_class') ||
                          inventoryType === 2 ||
                          inventoryType === 3 ? (
                              <td>{item.zone_class || '-'}</td>
                          ) : (
                              ''
                          )}
                          {property.haveVal('warehouse_code') ? (
                              <td>{item.warehouse_code}</td>
                          ) : (
                              ''
                          )}

                          {property.haveQtyVal('qty_soh') ? (
                              <td>
                                  <div className={styles.stock}>
                                      {item.qty_soh || 0}
                                  </div>
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_allocated') ? (
                              <td className={styles.grayout}>
                                  {item.qty_allocated || 0}
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_return') ? (
                              <td className={styles.grayout}>
                                  {item.qty_return || 0}
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_rejected') ? (
                              <td className={styles.grayout}>
                                  <div>{item.qty_rejected || 0}</div>
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_damaged') ? (
                              <td className={styles.grayout}>
                                  {item.qty_damaged || 0}
                              </td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty_other') ? (
                              <td className={styles.grayout}>
                                  {item.qty_other || 0}
                              </td>
                          ) : (
                              ''
                          )}

                          {property.haveQtyVal('qty_total') ? (
                              <td>{item.qty_total || 0}</td>
                          ) : (
                              ''
                          )}
                          {property.haveQtyVal('qty') ? (
                              <td>{item.qty || 0}</td>
                          ) : (
                              ''
                          )}
                      </tr>
                  );
              })
            : '';

    const box =
        data && !_.isEmpty(data)
            ? data.map((item, index) => (
                  <div>
                      <StockBox item={item} property={property} />
                  </div>
              ))
            : '';

    const direction = dir && dir === 'asc' ? 'desc' : 'asc';

    return (
        <div className={styles.ctr}>
            {browser && browser.greaterThan.tablet ? (
                <table className={styles.table}>
                    <thead>
                        {inventoryType === 1 && (
                            <tr className={styles.something}>
                                <td colspan={property.haveCreatedAt ? 5 : 4} />
                                <td colspan={5} className={styles.grayout}>
                                    <div className={styles.unavailable}>
                                        <div>
                                            {I18n.getText(
                                                'inventory.unavailable-stock',
                                            )}
                                        </div>
                                        <Tooltip
                                            className={styles.tooltip}
                                            place="bottom"
                                            type="light"
                                            border
                                            id={'unavailable'}
                                        >
                                            <div>
                                                {I18n.getHtml(
                                                    'inventory.unavailable-tooltip1',
                                                )}
                                            </div>
                                            <div>
                                                {I18n.getHtml(
                                                    'inventory.unavailable-tooltip2',
                                                )}
                                            </div>
                                            <div>
                                                {I18n.getHtml(
                                                    'inventory.unavailable-tooltip3',
                                                )}
                                            </div>
                                        </Tooltip>
                                        <div
                                            style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                            }}
                                            data-tip
                                            data-for={'unavailable'}
                                        >
                                            <Icon
                                                name="tooltip"
                                                className={styles.printIcon}
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td colspan={1} />
                            </tr>
                        )}
                        <tr className={`${styles.row} ${styles.head}`}>
                            {property.haveName || property.haveItems ? (
                                <th>{I18n.getText('product-table.name')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('sku') ? (
                                <th>{I18n.getText('product-table.sku')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('partner_sku_unique') ? (
                                <th>{I18n.getText('offer.p-sku-unique')}</th>
                            ) : (
                                ''
                            )}

                            {property.haveVal('pending_shipment') ? (
                                <th>
                                    {I18n.getText(
                                        'inventory-rstocks.pending-shipment',
                                        {},
                                        'Pending Shipment',
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('created_at') ? (
                                <th className={styles.titleFlexer}>
                                    {I18n.getText(
                                        'inventory-stocks.created-at',
                                        {},
                                        'Created at',
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('barcode_box') ||
                            inventoryType === 2 ||
                            inventoryType === 3 ? (
                                <th>
                                    {I18n.getText(
                                        'inventory-rejection.box-barcode',
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('reason_code') ||
                            inventoryType === 2 ||
                            inventoryType === 3 ? (
                                <th>
                                    {I18n.getText('transfers.rejected-reason')}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('area_code') ? (
                                <th>{I18n.getText('stocks.area-code')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('zone_class') ||
                            inventoryType === 2 ||
                            inventoryType === 3 ? (
                                <th
                                    className={styles.titleFlexer}
                                    onClick={() =>
                                        sortColumn('zone_class', direction)
                                    }
                                >
                                    {I18n.getText('stocks.zone-class')}
                                    {keyVal === 'zone_class' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('warehouse_code') ? (
                                <th>{I18n.getText('offer.warehouse-code')}</th>
                            ) : (
                                ''
                            )}

                            {property.haveQtyVal('qty_soh') ? (
                                <th
                                    className={styles.titleFlexer}
                                    onClick={() =>
                                        sortColumn('qty_soh', direction)
                                    }
                                >
                                    {I18n.getText('inventory.soh')}
                                    {keyVal === 'qty_soh' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_allocated') ? (
                                <th
                                    className={`${styles.titleFlexer} ${
                                        styles.grayout
                                    }`}
                                    onClick={() =>
                                        sortColumn('qty_allocated', direction)
                                    }
                                >
                                    {I18n.getText('inventory.allocated-qty')}
                                    {keyVal === 'qty_allocated' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_return') ? (
                                <th
                                    className={`${styles.titleFlexer} ${
                                        styles.grayout
                                    }`}
                                    onClick={() =>
                                        sortColumn('qty_return', direction)
                                    }
                                >
                                    {I18n.getText('inventory.returned')}
                                    {keyVal === 'qty_return' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}

                            {property.haveQtyVal('qty_rejected') ? (
                                <th
                                    className={`${styles.titleFlexer} ${
                                        styles.grayout
                                    }`}
                                    onClick={() =>
                                        sortColumn('qty_rejected', direction)
                                    }
                                >
                                    {I18n.getText('inventory-stocks.rejected')}
                                    {keyVal === 'qty_rejected' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_damaged') ? (
                                <th
                                    className={`${styles.titleFlexer} ${
                                        styles.grayout
                                    }`}
                                    onClick={() =>
                                        sortColumn('qty_damaged', direction)
                                    }
                                >
                                    {I18n.getText(
                                        'inventory-stocks.damage',
                                        {},
                                        'Damage',
                                    )}
                                    {keyVal === 'qty_damaged' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_other') ? (
                                <th
                                    className={`${styles.titleFlexer} ${
                                        styles.grayout
                                    }`}
                                    onClick={() =>
                                        sortColumn('qty_other', direction)
                                    }
                                >
                                    {I18n.getText('inventory-stocks.others')}
                                    {keyVal === 'qty_other' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_total') ? (
                                <th
                                    className={`${styles.titleFlexer}`}
                                    onClick={() =>
                                        sortColumn('qty_total', direction)
                                    }
                                >
                                    {I18n.getText('inventory-stocks.total')}
                                    {keyVal === 'qty_total' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty') ? (
                                <th
                                    className={`${styles.titleFlexer}`}
                                    onClick={() => sortColumn('qty', direction)}
                                >
                                    {I18n.getText('order-modal.qty')}
                                    {keyVal === 'qty' ? (
                                        <Icon
                                            name={
                                                direction === 'asc'
                                                    ? 'caret-down'
                                                    : 'caret-up'
                                            }
                                        />
                                    ) : (
                                        <Icon name={'caret-both'} />
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            ) : (
                box
            )}
        </div>
    );
};

export default Stocks;



// WEBPACK FOOTER //
// ./src/components/inventory/stocks/Stocks.js